import { c as _c } from "react/compiler-runtime";
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import IconProtectionPlan from 'components/icons/iconProtectionPlan';
import IconPetProtector from 'components/icons/iconPetProtector';
import ProgressLoaderDots from 'components/essentials/ProgressLoaderDots/ProgressLoaderDots';
import Currency from 'components/consumer/Currency';
import CtaLink from 'components/essentials/Cta/CtaLink';
import LoginSidebar from 'components/consumer/LoginSidebar/LoginSidebar';
import { Redirect } from 'react-router-dom';
import ProtectionPlanModal from 'components/consumer/ProtectionPlanModal';
import useUserData from 'data-hooks/useUserData';
const ProtectionPlanButtonAndModal = t0 => {
  const $ = _c(45);
  const {
    close,
    eligible_plans,
    forPage,
    isAddPPLoading,
    isOpen,
    isRemovePPError,
    isRemovePPLoading,
    onSelect,
    openModal,
    productId,
    removeProtectionPlan,
    selectedProtectionPlan,
    showInactiveProtectionPlan,
    showSignInPageUponSelection
  } = t0;
  const [showSignInModal, setShowSignInModal] = useState(false);
  const {
    isLoggedIn
  } = useUserData();
  const buttonRef = useRef(null);
  const accessibleLabel = selectedProtectionPlan ? `Remove ${selectedProtectionPlan.plan_name}` : "Add 5-year Protection Plan";
  let t1;
  if ($[0] !== close || $[1] !== eligible_plans || $[2] !== forPage || $[3] !== isOpen || $[4] !== onSelect || $[5] !== selectedProtectionPlan || $[6] !== showInactiveProtectionPlan) {
    t1 = <ProtectionPlanModal buttonRef={buttonRef} close={close} eligiblePlans={eligible_plans} forPage={forPage} isEdit={true} isOpen={isOpen} onSelect={onSelect} selectedPlan={selectedProtectionPlan} showInactiveProtectionPlan={showInactiveProtectionPlan} />;
    $[0] = close;
    $[1] = eligible_plans;
    $[2] = forPage;
    $[3] = isOpen;
    $[4] = onSelect;
    $[5] = selectedProtectionPlan;
    $[6] = showInactiveProtectionPlan;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== isLoggedIn || $[9] !== showSignInModal || $[10] !== showSignInPageUponSelection) {
    t2 = !isLoggedIn && showSignInPageUponSelection && showSignInModal ? <LoginSidebar show={showSignInModal} onClose={() => setShowSignInModal(false)} /> : null;
    $[8] = isLoggedIn;
    $[9] = showSignInModal;
    $[10] = showSignInPageUponSelection;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== isLoggedIn || $[13] !== showSignInPageUponSelection) {
    t3 = isLoggedIn && showSignInPageUponSelection && <Redirect to="/customer/orders" />;
    $[12] = isLoggedIn;
    $[13] = showSignInPageUponSelection;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== isRemovePPError) {
    t4 = isRemovePPError && <div className="text-sm font-bold text-red">{`${isRemovePPError}`}</div>;
    $[15] = isRemovePPError;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const t5 = !!selectedProtectionPlan;
  let t6;
  if ($[17] !== t5) {
    t6 = cx("flex relative items-center mt-0 min-h-[3rem] cursor-pointer border border-solid border-gray-light6 rounded p-3 bg-transparent text-left w-full", "hover:border hover:border-solid hover:border-gray-light2 hover:cursor-pointer", {
      active: t5
    });
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== openModal || $[20] !== productId || $[21] !== removeProtectionPlan || $[22] !== selectedProtectionPlan || $[23] !== showSignInPageUponSelection) {
    t7 = () => {
      if (showSignInPageUponSelection) {
        setShowSignInModal(true);
        return;
      }
      if (selectedProtectionPlan && removeProtectionPlan) {
        removeProtectionPlan(true);
      } else {
        openModal(productId);
      }
    };
    $[19] = openModal;
    $[20] = productId;
    $[21] = removeProtectionPlan;
    $[22] = selectedProtectionPlan;
    $[23] = showSignInPageUponSelection;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== eligible_plans?.[0]?.plan_price || $[26] !== forPage || $[27] !== isAddPPLoading || $[28] !== isRemovePPLoading || $[29] !== removeProtectionPlan || $[30] !== selectedProtectionPlan) {
    t8 = isAddPPLoading || isRemovePPLoading ? <ProgressLoaderDots /> : <>{selectedProtectionPlan ? <div className="w-12 h-12 mr-1">{selectedProtectionPlan.plan_name.includes("Pet Protector Plan") ? <IconPetProtector /> : <IconProtectionPlan />}</div> : <div />}<div className="cursor-pointer w-full flex items-center min-w-0">{selectedProtectionPlan ? <span className={`block ml-2 text-sm font-bold text-gray flex justify-between items-center gap-2 w-full min-w-0 ${forPage}`}><span className="flex-1 min-w-0 break-words">5-year {selectedProtectionPlan.plan_name}{" (+"}<Currency>{selectedProtectionPlan.plan_price}</Currency>{") "}</span>{removeProtectionPlan ? <span className="flex-shrink-0 text-xs font-bold text-brand hover:underline">Remove</span> : <span className="text-xs font-bold text-brand hover:underline"><CtaLink to="/furniture-protection-plan/" size="xs" target="_blank" color="brand" hasArrow={false}>See Details</CtaLink></span>}</span> : <><span className="w-12 h-12 mr-1"><IconProtectionPlan circleFill="none" fill="#e0e0e0" />{" "}</span><span className="block ml-2 text-sm font-bold text-gray w-full"><span className="flex whitespace-pre flex-col"><span className="whitespace-normal">{"Add 5-year Protection Plan from"}{" "}<Currency>{eligible_plans?.[0]?.plan_price}</Currency></span><span className="text-xs font-bold text-brand">What's covered?</span></span><span className="text-xs font-bold text-brand hover:underline" /></span></>}</div></>;
    $[25] = eligible_plans?.[0]?.plan_price;
    $[26] = forPage;
    $[27] = isAddPPLoading;
    $[28] = isRemovePPLoading;
    $[29] = removeProtectionPlan;
    $[30] = selectedProtectionPlan;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  let t9;
  if ($[32] !== accessibleLabel || $[33] !== t6 || $[34] !== t7 || $[35] !== t8) {
    t9 = <button data-xc="PDPAddProtectionPlanButton" className={t6} type="button" aria-label={accessibleLabel} title={accessibleLabel} ref={buttonRef} onClick={t7}>{t8}</button>;
    $[32] = accessibleLabel;
    $[33] = t6;
    $[34] = t7;
    $[35] = t8;
    $[36] = t9;
  } else {
    t9 = $[36];
  }
  let t10;
  if ($[37] !== t4 || $[38] !== t9) {
    t10 = <div className="mt-5">{" "}{t4}{t9}</div>;
    $[37] = t4;
    $[38] = t9;
    $[39] = t10;
  } else {
    t10 = $[39];
  }
  let t11;
  if ($[40] !== t1 || $[41] !== t10 || $[42] !== t2 || $[43] !== t3) {
    t11 = <>{t1}{t2}{t3}{t10}</>;
    $[40] = t1;
    $[41] = t10;
    $[42] = t2;
    $[43] = t3;
    $[44] = t11;
  } else {
    t11 = $[44];
  }
  return t11;
};
ProtectionPlanButtonAndModal.propTypes = {
  close: PropTypes.func,
  eligible_plans: PropTypes.arrayOf(PropTypes.shape({
    plan_name: PropTypes.string,
    plan_price: PropTypes.number
  })),
  forPage: PropTypes.oneOf(['cart', 'checkout', 'PDP', 'UserDashboardOrdersPage', 'UserDashboardPP']),
  isAddPPLoading: PropTypes.bool,
  isOpen: PropTypes.bool,
  isRemovePPError: PropTypes.string,
  isRemovePPLoading: PropTypes.bool,
  onSelect: PropTypes.func,
  openModal: PropTypes.func,
  productId: PropTypes.string,
  removeProtectionPlan: PropTypes.func,
  selectedProtectionPlan: PropTypes.shape({
    plan_name: PropTypes.string,
    plan_price: PropTypes.number
  }),
  showInactiveProtectionPlan: PropTypes.bool,
  showSignInPageUponSelection: PropTypes.bool
};
export default ProtectionPlanButtonAndModal;